import * as apis from './apis'
import { call, put } from 'redux-saga/effects'
import { setCitiesData } from './actions'
import { loadingStopped, loadingStarted, catchErrors } from '../app/actions'

// 州情報一覧を取得
export function* fetchCitiesSaga(action) {
  try {
    yield put(loadingStarted())

    const countryCode: string = action.payload.countryCode
    const res = yield call(apis.getCities, countryCode)

    yield put(setCitiesData(res.data))
  } catch (error) {
    switch (error.response.status) {
      // case 400:
      //   router.push('/404')
      //   break
      case 403:
        yield put(
          catchErrors(
            error.response?.data?.message || 'このアカウントは規約違反により削除されました。'
          )
        )
        break
      default:
        yield put(catchErrors(error))
        break
    }
  } finally {
    yield put(loadingStopped())
  }
}
